var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteTax(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8408",
    "data-name": "Group 8408",
    transform: "translate(-1685.866 -3529.686)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_167",
    "data-name": "Rectangle 167",
    width: 20,
    height: 20,
    transform: "translate(1685.866 3529.686)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8407",
    "data-name": "Group 8407",
    transform: "translate(1688.617 3531.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M1733.48,3552.7h1.177l-.589-1.371Z",
    transform: "translate(-1727.339 -3548.376)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M1712.449,3535.068H1701.3a1.671,1.671,0,0,0-1.671,1.672v15.49a.145.145,0,0,0,.258.091l1.849-2.274a.316.316,0,0,1,.48-.011l2.076,2.324a.317.317,0,0,0,.483-.011l1.859-2.292a.315.315,0,0,1,.487,0l1.924,2.289a.317.317,0,0,0,.49-.006l1.822-2.281a.315.315,0,0,1,.484-.011l2.025,2.305a.145.145,0,0,0,.254-.1V3536.74A1.672,1.672,0,0,0,1712.449,3535.068Zm-11.912,1.767h3.688v.9h-1.28v3.372h-1.128v-3.372h-1.28Zm5.485,10.922h-4.362a.453.453,0,1,1,0-.907h4.362a.453.453,0,1,1,0,.907Zm-4.815-2.174a.454.454,0,0,1,.454-.454h3.209a.454.454,0,0,1,0,.907h-3.209A.454.454,0,0,1,1701.206,3545.582Zm5.584-1.267h-5.13a.453.453,0,1,1,0-.907h5.13a.453.453,0,1,1,0,.907Zm5.382,3.409a1.927,1.927,0,0,1-1.049.526v.792h-.982v-.764a3.517,3.517,0,0,1-.839-.165,2.46,2.46,0,0,1-.67-.333l.4-.912a2.654,2.654,0,0,0,1.473.442q.772,0,.772-.491a.329.329,0,0,0-.21-.312,3.862,3.862,0,0,0-.694-.221,6.4,6.4,0,0,1-.856-.273,1.526,1.526,0,0,1-.586-.435,1.187,1.187,0,0,1-.249-.792,1.337,1.337,0,0,1,.393-.961,1.951,1.951,0,0,1,1.038-.541v-.8h.982v.772a3.621,3.621,0,0,1,.758.186,1.9,1.9,0,0,1,.568.312l-.4.912a3.046,3.046,0,0,0-.687-.333,2.128,2.128,0,0,0-.666-.115.927.927,0,0,0-.516.126.4.4,0,0,0-.193.358.346.346,0,0,0,.123.27.86.86,0,0,0,.3.168q.182.059.519.144a6.219,6.219,0,0,1,.842.252,1.393,1.393,0,0,1,.575.428,1.225,1.225,0,0,1,.239.792A1.337,1.337,0,0,1,1712.172,3547.725Zm-.261-6.614-.964-1.346-.971,1.346h-2.287l-.382-.885h-1.892l-.382.885h-1.122l2-4.276h.885l1.96,4.187,1.564-2.07-1.6-2.117h1.3l.934,1.31.946-1.31h1.292l-1.608,2.117,1.638,2.159Z",
    transform: "translate(-1699.631 -3535.068)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteTax);
export default __webpack_public_path__ + "static/media/white_tax.08520c4c3e097e384556a7dcf5e4fc46.svg";
export { ForwardRef as ReactComponent };